module.exports = "<div *ngIf=\"creating\" class=\"loading\">\n  <span class=\"spinning icon ion-load-c\"></span> &nbsp;Creating Flyer...\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/create/create.component.html
// module id = 189
// module chunks = 1